module.exports = __webpack_public_path__ + "media/images/sp/lp/bg-presentAmazon-right-cb27a6ff7fc156598e9bcc6a55acdfc3.png";